/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PlaceToSleepEnum = (typeof PlaceToSleepEnum)[keyof typeof PlaceToSleepEnum];

export const PlaceToSleepEnum = {
  main_bed: 'main_bed',
  guest_bed: 'guest_bed',
  couch: 'couch',
  other: 'other',
} as const;
